// extracted by mini-css-extract-plugin
export default {"subHeader":"Consent_subHeader__MS2jO","paragraph":"Consent_paragraph__tDNKx","listHeader":"Consent_listHeader__DF-Xb","list":"Consent_list__Gk49L"};